export default __webpack_public_path__ + "static/media/media-auto-4.49a1d151.jpg";